import React from 'react';
import PropTypes from 'prop-types';
import LoadDetailsSide from 'components/LoadDetailsSide';
import moment from 'moment-timezone';
import StatusTag from 'components/StatusTag';

const JourneyInfoSide = ({ className, journey }) => {
  return (
    <div className={className} data-testid="journey-info-side">
      <div className="journey-info-side">
        <div className="journey-info-side__status">
          <StatusTag status={journey.status} />
        </div>
        <div className="journey-info-side__header">
          <div className="journey-info-side__date">
            {moment(journey.start_time_from)
              .tz(journey.start_time_from_tz)
              .format('dddd, D MMM')}
          </div>
          <div className="journey-info-side__id">{`J${journey.id}`}</div>
        </div>
        <div className="journey-info-side__load-info">
          <LoadDetailsSide
            numberOfItems={journey.max_equivalent_pallets}
            mass={journey.sum_weight}
            height={journey.item_height}
            extras={journey.extras}
            bottomAlign
          />
        </div>
      </div>
    </div>
  );
};

JourneyInfoSide.propTypes = {
  journey: PropTypes.object.isRequired
};

export default JourneyInfoSide;
